/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cityrequired1Inputs */

const en_cityrequired1 = /** @type {(inputs: Cityrequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City is required`)
};

const de_cityrequired1 = /** @type {(inputs: Cityrequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stadt ist erforderlich`)
};

/**
* | output |
* | --- |
* | "City is required" |
*
* @param {Cityrequired1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cityrequired1 = /** @type {((inputs?: Cityrequired1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cityrequired1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cityrequired1(inputs)
	return de_cityrequired1(inputs)
});
export { cityrequired1 as "cityRequired" }